import {apiPost} from './api';

export default class ServicioCatalogos {
  static getEstados() {
    const cache = this.obtenerCatalogoCache('estados');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/Estados', {});
  }

  static getAgendaTipos() {
    const cache = this.obtenerCatalogoCache('agendatipos');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/AgendaTipos', {});
  }

  static getGeneros() {
    const cache = this.obtenerCatalogoCache('generos');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/Generos', {});
  }

  static getMuestrasTipos() {
    return apiPost('/catalogos/AgendaTipos', {});
  }

  static getPagosTipos() {
    const cache = this.obtenerCatalogoCache('pagostipos');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/PagosTipos', {});
  }

  static getEmpresas() {
    const cache = this.obtenerCatalogoCache('empresas');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/Empresas', {});
  }

  static getEnfermeras() {
    const cache = this.obtenerCatalogoCache('enfermeras');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/Enfermeras', {});
  }

  static getMuestrasEstados() {
    const cache = this.obtenerCatalogoCache('muestrasestados');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/MuestrasEstados', {});
  }

  static getAnalisisTipos() {
    const cache = this.obtenerCatalogoCache('analisistipos');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/AnalisisTipos', {});
  }

  static getExtraccionTipos() {
    const cache = this.obtenerCatalogoCache('extracciontipos');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/ExtraccionTipos', {});
  }

  static getKits() {
    const cache = this.obtenerCatalogoCache('kits');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/Kits', {});
  }
  static getMuestrasEstatus() {
    const cache = this.obtenerCatalogoCache('muestrasestatus');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/MuestrasEstatus', {});
  }

  static getPCRInterpretaciones() {
    const cache = this.obtenerCatalogoCache('pcrinterpretaciones');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/PCRInterpretaciones', {});
  }

  static getCertificadosEstados() {
    const cache = this.obtenerCatalogoCache('certificadosestados');
    if (cache) {
      return new Promise((resolve) => {
        resolve(cache);
      });
    }
    return apiPost('/catalogos/CertificadosEstados', {});
  }

  static obtenerCatalogoCache(catalogo) {
    const cat = localStorage.getItem(`cat_${catalogo}`);
    if (cat) {
      return JSON.parse(cat);
    } else {
      return null;
    }
  }
}
